// import React from "react";
// import "./Gharshya_drop.css";

// export default function Ghrshya_drop() {
//   return (
//     <section className="drops-section drops-banner-wrap">
//       {/* HERO BANNER */}
//       <div className="drops-hero">
//         <div className="drops-hero-overlay">
//           <h1 className="drops-hero-title">Garshya Drops</h1>
//           <p className="drops-hero-text">Limited-time products</p>
//           <div className="drops-flex-center">
//             {/* <button className="drops-btn-primary">Explore Now</button> */}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useState } from "react";
import "./Curated.css";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Ghrshya_drop() {
  const [curatedPicks, setCuratedPicks] = useState([]);
  
      useEffect(() => {
          const fetchData = async () => {
              const response = await axios.post("https://cyberathon.com/multivendor/index.php/Api/Master_controller/getCuratedPicks");
              const filteredData = response.data.data.slice(7, 8);
              setCuratedPicks(filteredData);
          }
          fetchData();
      }, [])

  return (
    <section className="cur2-se cur-banner">

      {/* HERO BANNER */}
        {curatedPicks.map((pick, index) => (
      <div key={index} className="cur2-hero"
      >
          <div  className="cur2-hero-item">
            <img src={`https://cyberathon.com/multivendor/${pick.image}`} alt={pick.heading} />
          </div>
        <div className="cur2-overlay">
          <h1>{pick.tag}</h1>
          <p>{pick.heading}</p>
          <div className="d-flex justify-content-center align-items-center">
          <Link
  to={`/products?category=${pick.category_id}&subcategory=${pick.subcategory_id}`}
  className="shop-now"
>
         <button className="Addto-cart">
          Shop Now →
        </button>
        </Link>
          </div>
        </div>
      </div>
        ))}

      {/* SECTION HEADING */}
      {/* <p className="cur2-title">Trending Right Now</p> */}

      {/* CATEGORY CARDS */}
      {/* <div className="cur2-products">
        {categories.map((item) => (
          <div key={item.id} className="cur2-card">
            <div className="cur2-img-wrap">
              <img src={item.image} alt={item.subtitle} loading="lazy" />
              {item.badge && <span className="cur2-badge">{item.badge}</span>}
            </div>
            <div className="cur2-card-info">
              <p className="cur2-card-label">{item.label}</p>
              <p className="cur2-card-subtitle">{item.subtitle}</p>
            </div>
          </div>
        ))}
      </div> */}

    </section>
  );
}